import env from '@/env';
import { status } from '@/alas';
import { defineComponent, computed, ref, onMounted, reactive } from '@vue/composition-api';
export default defineComponent({
    setup(props, context) {
        let router = context.root.$router;
        // ================
        //
        // ref
        //
        let user = ref(status.fetch('user'));
        let farms = ref(status.fetch('farms'));
        // ================
        //
        // state
        //
        let $ = reactive({
            env
        });
        // ================
        //
        // computed
        //
        let points = computed(() => {
            return farms.value.items.map(model => {
                return {
                    lat: model.latitude,
                    lng: model.longitude,
                    click: () => {
                        router.push({
                            name: 'farms.overview',
                            params: {
                                id: model.id
                            }
                        });
                    }
                };
            });
        });
        // ================
        //
        // mounted
        //
        onMounted(() => {
            if (user.value) {
                farms.value.o.fetch.seek();
            }
        });
        // ================
        //
        // done
        //
        return {
            $,
            user,
            farms,
            points
        };
    }
});
